module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-1_active-e25604fb246b638ae2e3b67d8e43d7d9.svg";